import {
  MapContainer,
  TileLayer,
  ScaleControl,
  GeoJSON,
  Marker,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
// @ts-ignore
import MarkerClusterGroup from '@changey/react-leaflet-markercluster';
import L from "leaflet";
import { useState } from "react";

const mapPolygonColorToDensity = (density: any) => {
  return density > 100
    ? "#a50f15"
    : density > 80
    ? "#de2d26"
    : density > 60
    ? "#fb6a4a"
    : density > 40
    ? "#fc9272"
    : density > 20
    ? "#fcbba1"
    : "#fee5d9";
};

const createCustomIcon = (ele: any) => {
  return L.divIcon({
    className: "", // No default styles
    html: `
    <svg width="16" height="16" viewBox="0 0 16 16">
    <g>
      <ellipse cx="8" cy="11" rx="5" ry="5" fill=${
        ele?.cumulitivePer <= 20
          ? "#006400"
          : ele?.cumulitivePer > 20 && ele?.cumulitivePer <= 50
          ? "#F58427"
          : "#ffffff"
      } />
      
    </g>
  </svg>
    `,
    iconSize: [10, 10],
    iconAnchor: [12, 16], // Anchor at the "tip" (bottom center)
  });
};

const createCustomIcon1 = (ele: any) => {
  return L.divIcon({
    className: "", // No default styles
    html: ` <svg width="20" height="20" viewBox="0 0 20 20">
    <line x1="4" y1="4" x2="16" y2="16" stroke="#0074D9" stroke-width="3"/>
    <line x1="16" y1="4" x2="4" y2="16" stroke="#0074D9" stroke-width="3"/>
  </svg>`,
    iconSize: [10, 10],
    iconAnchor: [12, 16], // Anchor at the "tip" (bottom center)
  });
};

const MapView = (props: any) => {
  const { data, dataCity,showGraph } = props;
  const position: any = { lat: 40.526, lng: -100.2551 }; // Coordinates for North America
  

  return (
    <MapContainer  center={position} zoom={3}                                                            
    minZoom={3}                                              
    scrollWheelZoom={false}                 
    touchZoom={false}  className="!h-[99%] w-full">
      <TileLayer url="https://a.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png" />
      <ScaleControl position="bottomright" />
      {showGraph?.high&&dataCity?.high?.map((ele: any, idx: number) => {
        if (
          ele.latitude == null ||
          ele.longitude == null ||
          isNaN(ele.latitude) ||
          isNaN(ele.longitude)
        ) {
          return null; // Skip invalid entries
        }
        return (
          <Marker
            key={idx}
            position={[ele.latitude, ele.longitude]}
            icon={createCustomIcon(ele)}
          />
        );
      })}

    {showGraph?.medium&&dataCity?.medium?.map((ele: any, idx: number) => {
        if (
          ele.latitude == null ||
          ele.longitude == null ||
          isNaN(ele.latitude) ||
          isNaN(ele.longitude)
        ) {
          return null; // Skip invalid entries
        }
        return (
          <Marker
            key={idx}
            position={[ele.latitude, ele.longitude]}
            icon={createCustomIcon(ele)}
          />
        );
      })}

{/* {showGraph?.low&&dataCity?.low?.map((ele: any, idx: number) => {
        if (
          ele.latitude == null ||
          ele.longitude == null ||
          isNaN(ele.latitude) ||
          isNaN(ele.longitude)
        ) {
          return null; // Skip invalid entries
        }
        return (
          <Marker
            key={idx}
            position={[ele.latitude, ele.longitude]}
            icon={createCustomIcon(ele)}
          />
        );
      })} */}
      {showGraph?.graybar&&dataCity?.graybar?.map((ele: any, idx: number) => {
        if (
          ele.latitude == null ||
          ele.longitude == null ||
          isNaN(ele.latitude) ||
          isNaN(ele.longitude)
        ) {
          return null; // Skip invalid entries
        }else if(ele?.gbmarketShare<ele?.overallGBShare){
          return null
        }
        return (
          <Marker
            key={idx}
            position={[ele.latitude, ele.longitude]}
            icon={createCustomIcon1(ele)}
          />
        );
      })}
    </MapContainer>
  );
};

export default MapView;
